// Buttons and images combined in a single list with the exact order from the image
export type GridItem = {
    name?: string;
    image?: string;
    type: 'button' | 'image' | 'gap';
    url?: string;
    modal?: string;
    isAction?: boolean;
    active?: boolean;
    value?: string | null;
    disabled?: boolean;
    tooltip?: string;
};

const buttonList = [
    {
        name: "nurse.patient-list.detail-grid.lab-results",
        image: "/assets/icons/pages/nurse/detail-grid/lab-results.svg",
        url: "/nurse/patient-list/detail/",
        type: 'button',
        isAction: true,
        disabled: true,
        tooltip: "under-development",
    },
    {
        name: "nurse.patient-list.detail-grid.pathology-results",
        image: "/assets/icons/pages/nurse/detail-grid/pathology-results.svg",
        url: "/nurse/patient-list/pathology/",
        type: 'button',
        isAction: true,
        disabled: true,
        tooltip: "under-development",
    },
    {
        name: "nurse.patient-list.detail-grid.radiology-results",
        image: "/assets/icons/pages/nurse/detail-grid/radiology-results.svg",
        url: "/nurse/patient-list/isolation/",
        type: 'button',
        isAction: true,
        disabled: true,
        tooltip: "under-development",
    },
    {
        name: "nurse.patient-list.detail-grid.nurse",
        image: "/assets/icons/pages/nurse/detail-grid/nurse.svg",
        url: "/nurse/patient-list/nurse/",
        type: 'button',
        isAction: true,
        disabled: true,
        tooltip: "under-development",
    },
    {
        name: "nurse.patient-list.detail-grid.patient-monitoring",
        image: "/assets/icons/pages/nurse/detail-grid/life-datas.svg",
        url: "/medcard/patient-monitoring/",
        type: 'button',
        isAction: true,
    },
    {
        name: "nurse.patient-list.detail-grid.height-weight-trace",
        image: "/assets/icons/pages/nurse/detail-grid/height-weight.svg",
        url: "/medcard/height-weight/",
        type: 'button',
        isAction: true,
    },
    {
        name: "nurse.patient-list.detail-grid.newborn-trace",
        image: "/assets/icons/pages/nurse/detail-grid/newborn-trace.svg",
        url: "/medcard/newborn-trace/",
        type: 'button',
        isAction: true
    },
    {
        name: "nurse.patient-list.detail-grid.pediatri",
        image: "/assets/icons/pages/nurse/detail-grid/pediatri.svg",
        url: "/medcard/pediatric-assessment/",
        type: 'button',
        isAction: true
    },
    {
        name: "nurse.patient-list.detail-grid.opened-cards",
        image: "/assets/icons/pages/nurse/detail-grid/opened-cards.svg",
        modal: "opened-medcards",
        type: 'button',
        isAction: true
    },
    {
        name: "nurse.patient-list.detail-grid.treatment-application",
        image: "/assets/icons/pages/nurse/detail-grid/treatment-application.svg",
        url: "/nurse/patient-list/treatment/",
        modal: "treatment-applications",
        type: 'button',
        isAction: true
    },
    {
        name: "nurse.patient-list.detail-grid.patient-processes",
        image: "/assets/icons/pages/nurse/detail-grid/processes.svg",
        url: "/nurse/patient-process/",
        type: 'button',
        isAction: true
    },
    {
        name: "nurse.patient-list.detail-grid.vital-signs",
        image: "/assets/icons/pages/nurse/detail-grid/life-datas.svg",
        url: "/medcard/vital-signs/",
        type: 'button',
        isAction: true,
    },
    {
        name: "nurse.patient-list.detail-grid.patient-table",
        image: "/assets/icons/nurse/patient-table.svg",
        url: "/nurse/patient-table/",
        type: 'button',
        isAction: true,
    },
] as const;

export default buttonList;
